'use client';

import { useDarkMode } from '@/lib/platform/contexts/dark-mode-context';
import { PrimaryButton } from '@/components/platform/buttons';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
}

export default function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  const { darkMode } = useDarkMode();

  return (
    <div className="py-12 text-center">
      {icon ? (
        <div className={`mx-auto size-12 ${darkMode ? 'text-gray-400' : 'text-gray-400'}`}>
          {icon}
        </div>
      ) : (
        <svg
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
          className={`mx-auto size-12 ${darkMode ? 'text-gray-400' : 'text-gray-400'}`}
        >
          <path
            d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            strokeWidth={2}
            vectorEffect="non-scaling-stroke"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      <h3 className={`mt-2 text-sm font-semibold ${darkMode ? 'text-gray-100' : 'text-gray-900'}`}>
        {title}
      </h3>
      <p className={`mt-1 text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        {description}
      </p>
      {action && (
        <div className="mt-6">
          <PrimaryButton
            type="button"
            onClick={action.onClick}
            size="lg"
            className="inline-flex items-center rounded-md"
          >
            {action.icon && (
              <span className="mr-1.5 -ml-0.5 size-5" aria-hidden="true">
                {action.icon}
              </span>
            )}
            {action.label}
          </PrimaryButton>
        </div>
      )}
    </div>
  );
}
